/*
  BY: Robin Hartmann ( https://stackoverflow.com/users/3859863/robin-hartmann )
  URL: https://stackoverflow.com/questions/12460378/how-to-get-json-from-url-in-javascript#answer-35970894
  Helps you get json data from a link, then call a function with said data
  
  USAGE
  ------
  getJSON('http://query.yahooapis.com/v1/public/yql?q=select%20%2a%20from%20yahoo.finance.quotes%20WHERE%20symbol%3D%27WRC%27&format=json&diagnostics=true&env=store://datatables.org/alltableswithkeys&callback',
    function(err, data) {
      if (err !== null) {
        alert('Something went wrong: ' + err);
      } else {
        alert('Your query count: ' + data.query.count);
      }
    });
  ------
*/
var getJSON = function(url, callback) {
  // IE11 doesn't support xhr.response = "json"; 
  // so we get it in text format then parse it for those browsers
  var IEversion = detectIE();
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = (IEversion && IEversion < 12) ? 'text' : 'json';
  xhr.onload = function() {
    var status = xhr.status;
    var theData = ( (typeof xhr.response) == "string") ? JSON.parse(xhr.response) : xhr.response;
    if (status === 200) {
      callback(null, theData);
    } else {
      callback(status, theData);
    }
  };
  xhr.send();
};